import React, { useEffect } from 'react';
import { getWillShowNav4 } from '@atlassian/jira-navigation-apps-sidebar-nav4-rollout-core/src/common/utils/get-will-show-nav4/index.tsx';
import { APP_NAMES } from '@atlassian/jira-servicedesk-common/src/utils/app-names/index.tsx';
import { useArticleId } from '@atlassian/jira-servicedesk-knowledge-common/src/controllers/store/index.tsx';
import KnowledgeBaseBreadcrumb from '@atlassian/jira-servicedesk-knowledge-hub/src/view/common/knowledge-base-breadcrumb/index.tsx';
import KnowledgeHubBrowseAll from '@atlassian/jira-servicedesk-knowledge-hub/src/view/knowledge-hub-browse-all-articles/index.tsx';
import { KnowledgeHubAppBase } from '@atlassian/jira-spa-apps-knowledge-hub-app-base/src/index.tsx';
import { MarkProductStart } from '@atlassian/jira-spa-performance-breakdown/src/utils/mark-product-start/index.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';

const View = () => {
	const [, { resetDraftArticleData }] = useArticleId();

	useEffect(
		() => () => {
			// We want to reset deleted so that this flag doesn't show up in any other component
			resetDraftArticleData(true);
		},
		[resetDraftArticleData],
	);

	return (
		<UFOSegment name="knowledge-hub-browse-all-articles">
			<MarkProductStart />
			<KnowledgeHubAppBase
				appName={APP_NAMES.KB_BROWSE_ARTICLES}
				shouldRemoveMargin={getWillShowNav4()}
			>
				{({ match, query, pageContext }) => (
					<KnowledgeBaseBreadcrumb>
						<KnowledgeHubBrowseAll
							page={match?.params?.pageId}
							sortBy={query?.sortBy}
							cursor={query?.cursor}
							searchQuery={query?.searchQuery}
							spaceKey={query?.spaceKey}
							activationId={pageContext?.activationId}
						/>
					</KnowledgeBaseBreadcrumb>
				)}
			</KnowledgeHubAppBase>
		</UFOSegment>
	);
};

export default View;
